import { FormattedMessage } from 'react-intl';

export const Copyright = () => {
  return (
    <div className="flex justify-between order-2 md:rounded-tr-[10px] text-[12px] leading-[12px] md:text-[14px] md:leading-[14px] font-medium md:rounded-tl-[10px] w-[calc(100% + 30px)] ml-[-15px] mr-[-15px] md:ml-0 md:mr-0 md:w-full mx-auto text-white bg-primary px-[15px] py-[19px] md:p-[20px] lg:py-[20px] lg:px-[30px]">
      <div>
        <a href="https://www.hellobello.at/" className=" text-hover-primary">
          HelloBello &copy;
        </a>
        <span className=""> {new Date().getFullYear()}</span>
      </div>
      <div>
        <p>
          <FormattedMessage id="FOOTER.SLOGAN" />
        </p>
      </div>
    </div>
  );
};
